import { softResetState as resetOrdersState } from './actions';
import { resetState as resetMenuItemsState } from '../menuItems/actions';

export default {
  onVisit: [resetOrdersState(), resetMenuItemsState()]
};
